import type { CSSProperties } from 'react';

import {
  BOTTOM_AXIS_LINE_OFFSET,
  TOP_AXIS_LINE_OFFSET,
  TICK_LINE_HEIGHT,
  TICK_LINE_ICON_OFFSET,
} from '../../../../core/components/axes/constants.js';
import type { TickRendererProps } from '../../../../core/components/axes/types.js';

export function useXTickOffset(
  textWidth: number,
  textHeight: number,
  renderProps: TickRendererProps,
  centerTick: boolean,
  isTickRotated: boolean,
  position: 'top' | 'bottom',
  tickNameHasEmoji: boolean,
) {
  const yOffset =
    position === 'top' && !isTickRotated
      ? TOP_AXIS_LINE_OFFSET
      : BOTTOM_AXIS_LINE_OFFSET;

  const size = isTickRotated ? textHeight + 2 : textWidth;

  const xOffset = centerTick
    ? size / 2
    : renderProps.textAnchor === 'start'
    ? 0
    : renderProps.textAnchor === 'end'
    ? size
    : size / 2;

  const { x, y, ...restProps } = renderProps;

  const TICK_LINE_HEIGHT_VALIDATED = tickNameHasEmoji
    ? TICK_LINE_HEIGHT + TICK_LINE_ICON_OFFSET
    : TICK_LINE_HEIGHT;

  const style: CSSProperties = {
    ...(restProps as CSSProperties),
    width: textWidth,
    height: TICK_LINE_HEIGHT_VALIDATED,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    display: 'inline-block',
  };

  if (isTickRotated) {
    style.transform = 'rotate(-90deg)';
  }

  return { xOffset, yOffset, style };
}
